import { ApplicantType } from "shared/types";

export const roles = [
  {
    value: ApplicantType.Applicant,
    label: "Applicant",
    description: (property) =>
      `Anyone over 18 living in the ${property}, such as a roommate, spouse, or partner`
  },
  {
    value: ApplicantType.CoSigner,
    label: "Guarantor",
    description: (property) =>
      `A person who won't live in the ${property} but will provide financial support`
  },
  {
    value: ApplicantType.Occupant,
    label: "Occupant",
    description: (property) =>
      `A person lives in the ${property} but is not financially responsible for the lease`
  }
];
